module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "CTA"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Contents#epi"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "imgdes2"
  }, [_c('img', {
    attrs: {
      "src": "Images/designtop.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CEPI1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageviii",
      "title": "viii"
    }
  }), _vm._v("With fame comes opportunity, but it also includes responsibility—to advocate and share, to focus less on glass slippers and more on pushing through glass ceilings. And, if I’m lucky enough, to inspire.")]), _vm._v(" "), _c('p', {
    staticClass: "CEPC"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EGHAN")]), _vm._v(" M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ARKLE")])]), _vm._v(" "), _c('p', {
    staticClass: "CEPI"
  }, [_vm._v("The world is changing as everybody knows, and we’ve changed with it. I think everybody can see that.")]), _vm._v(" "), _c('p', {
    staticClass: "CEPC"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("RINCE")]), _vm._v(" H"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ARRY OF")]), _vm._v(" W"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ALES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b90926a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Epigraph.vue
// module id = 66
// module chunks = 0